<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">{{'Vendor Email' | wordReplace}}</h5>
            </div>
            <hr />
            <form [formGroup]="EmailTemplateForm">
                <div class="container-fluid">
                    <div class="row align-items-center mb-2">
                        <div class="col-label">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="useTemplate"
                                    formControlName="UseEmailTemplate">
                                <label class="form-check-label" for="useTemplate">
                                    Use Email Template
                                </label>
                            </div>
                        </div>
                        <div class="col-field d-flex align-items-center">
                            <label class="me-2 mb-0">Template Name</label>
                            <select class="form-select template-select"
                                [disabled]="!EmailTemplateForm.get('UseEmailTemplate')?.value"
                                (change)="onTemplateChange($event)" formControlName="SelectedTemplateId">
                                <option [value]="null">Choose Template</option>
                                @for (et of EmailTemplateList; track et.EmailTemplateId) {
                                <option [value]="et.EmailTemplateId">{{ et.TemplateName }}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="row align-items-center mb-2">
                        <div class="col-label">
                            <label class="mb-0">Subject</label>
                        </div>
                        <div class="col-field">
                            <input type="text" class="form-control field-input" formControlName="Subject"
                                placeholder="Enter subject" maxlength="100">
                            <!-- Validation Message -->
                            <div class="text-danger mt-1" *ngIf="EmailTemplateForm.get('Subject')?.touched 
              && EmailTemplateForm.get('Subject')?.errors?.['required']">
                                &nbsp;* required
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-label">
                            <label class="mb-0">Attachment</label>
                        </div>
                        <div class="col-field">
                            <input type="file" class="form-control field-input" (change)="onFileSelected($event)"
                                accept=".png,.jpg,.jpeg,.pdf">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-start mt-2">
                        <div class="NgxEditor__Wrapper">
                            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                            <ngx-editor [editor]="editor" formControlName="TemplateContent"
                                [placeholder]="'Type here...'"></ngx-editor>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row align-items-center mt-3">
                <div class="col-auto">
                    <div class="btn-group" role="group">
                        <button type="button" class="btn btn-light shadow-sm"
                            [class.active]="selectedVendorFilter === 'current'" (click)="applyVendorFilter('current')">
                            {{'Current Vendors' | wordReplace}}
                        </button>
                        <button type="button" class="btn btn-light shadow-sm"
                            [class.active]="selectedVendorFilter === 'all'" (click)="applyVendorFilter('all')">
                            {{ 'All Vendors' | wordReplace}}
                        </button>
                        <button type="button" class="btn btn-light shadow-sm"
                            [class.active]="selectedVendorFilter === 'inactive'"
                            (click)="applyVendorFilter('inactive')">
                            Inactive
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <ejs-grid #gridVendorEmail [dataSource]="filteredVendorList" [allowFiltering]="true"
                        (created)='created($event)' [selectionSettings]="selectionSettings"
                        (rowSelected)="onRowSelected($event)" (rowDeselected)="onRowDeselected($event)"
                        (actionBegin)="onGridActionBegin($event)" (dataBound)="onGridDataBound()" height="300">
                        <e-columns>
                            <e-column field="VendorId" isPrimaryKey="true" visible="false" width="0"></e-column>
                            <e-column type="checkbox" width="50"></e-column>
                            <e-column field="VendorAlphaId" [headerText]="'Vendor ID' | wordReplace"
                                width="120"></e-column>
                            <e-column field="VendorName" [headerText]="'Vendor Name' | wordReplace"
                                width="150"></e-column>
                            <e-column field="VendorState" [headerText]="'Vendor State' | wordReplace"
                                width="120"></e-column>
                            <e-column field="VendorCity" [headerText]="'Vendor City' | wordReplace"
                                width="150"></e-column>
                            <e-column field="VendorZipcode" [headerText]="'Vendor Zipcode' | wordReplace"
                                width="150"></e-column>
                            <e-column field="Email" headerText="Email" width="200"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-end my-2">
                    <ejs-tooltip id='tooltipVendorEmail' target="#btnVendorEmail" position='TopCenter' openMode="Auto"
                        windowCollision="fit" (beforeOpen)="onBeforeOpen($event)"
                        [content]="'You do not have rights to Send Vendor Email' | wordReplace">
                        <button id="btnVendorEmail" type="button" class="btn btnAS me-1" (click)="sendVendorEmail()"
                            [userPermissionHandler]="createPermissionHandlerData">
                            Send
                        </button>
                    </ejs-tooltip>
                    <button class="btn btn-orange" (click)="closeVendorEmailPage()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>